import { UserProfile } from 'api/account/models/UserProfile';
import UsersService from 'api/users/UsersService';
import ScreenContainer from 'common/components/screenContainer/ScreenContainer';
import ScreenHeader from 'common/components/screenHeader/ScreenHeader';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import Tabs, { TabItem } from 'common/components/tabs/Tabs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Reducers } from 'store/types';
import RolesDetails from './components/rolesTab/components/rolesDetails/RolesDetails';
import RolesList from './components/rolesTab/components/rolesList/RolesList';
import RulesTab from './components/rulesTab/RulesTab';
import UsersDetails from './components/usersTab/components/usersDetails/UsersDetails';
import UsersList from './components/usersTab/components/usersList/UsersList';

const SecurityScreen = () => {
    const { t } = useTranslation();
    const { tabId, type, id } = useParams<{ tabId: string, type: string, id: string }>();
    const history = useHistory();

    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasUsersReadPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_USERS_READ']);
    const hasRolesReadPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_ROLES_READ']);
    const hasRulesReadPolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_RULES_READ']);

    const defaultTab = (!!tabId ? tabId : hasUsersReadPolicy ? 'users' : (hasRolesReadPolicy ? 'roles' : 'rules'));

    const changeTab = (tId: string) => {
        history.push(`/security/${tId}`)
    }

    const tabs: TabItem[] = useMemo(() => {
        const items: TabItem[] = [];
        if (hasUsersReadPolicy) {
            items.push({
                id: 'users',
                title: t('users.title'),
                content: tabId === 'users' && type ? <UsersDetails /> : <UsersList />
            });
        }
        if (hasRolesReadPolicy) {
            items.push({
                id: 'roles',
                title: t('roles.title'),
                content: tabId === 'roles' && type ? <RolesDetails /> : <RolesList />
            });
        }
        if (hasRulesReadPolicy) {
            items.push({
                id: 'rules',
                title: t('rules.title'),
                content: <RulesTab />
            });
        }
        return items;
    }, [tabId, type, id]);

    return (
        <ScreenTitle title={t('menu.security')}>
            <ScreenContainer>
                <ScreenHeader title={t('menu.security')} />
                <Tabs
                    items={tabs}
                    activeTabId={defaultTab}
                    onChange={(tId: string) => { !type && changeTab(tId) }}
                />
            </ScreenContainer>
        </ScreenTitle>
    );
}

export default SecurityScreen;
